import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent, encodeGetParams } from "../../api";
import { apiUrlV1 } from "../../config/config";
import { BonusWalletReward, BonusGameReward, IReqBonusData } from "../../entities/bonus";
import { ApiQueryParams } from "../../entities/global";
import { addNotification } from "../Notification/notificateStore";
import { unauthorizedHandler } from "../Auth/authStore";

export const getBonuses = createAsyncThunk(
  'bonus/list',
  async (params: ApiQueryParams, thunkApi): Promise<IReqBonusData> => {
    const query = encodeGetParams({ ...params })
    const req = await agent.get(`${apiUrlV1}/organization/bonus/list${query}`);
    if (req.ok) {
      const res = await req.json() as IReqBonusData;
      return res;
    }
    if (!req.ok && req.status === 401) {
      const body = await req.json();
      thunkApi.dispatch(unauthorizedHandler({ code: body.statusCode, message: body.message, status: true }))
      throw Error("No response");
    }
    return {
      data: [],
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
    };
  }
);

export const createBonuse = createAsyncThunk(
  'bonus/added',
  async (params: { name: string, customerBonusId: string, config?: Record<string, any>, value?: number, walletRewards?: BonusWalletReward[], gameRewards?: BonusGameReward[], external?: boolean }, thunkApi): Promise<IReqBonusData['data'][0]> => {
    const { name, customerBonusId, config, value, walletRewards, gameRewards, external } = params
    const req = await agent.post(`${apiUrlV1}/organization/bonus`, {
      body: JSON.stringify({ name, customerBonusId, config, value, walletRewards, gameRewards, external })
    })
    if (req.ok) {
      const data = await req.json();
      thunkApi.dispatch(getBonuses({}));
      thunkApi.dispatch(addNotification({ status: 'success', text: "Successfully saved" }))
      return data;
    }
    const data = await req.json() as { message: string }
    thunkApi.dispatch(addNotification({ status: 'error', text: data.message }))
    throw Error(data.message || "Failed to create bonus");
  }
)

export const updateBonuseById = createAsyncThunk(
  'bonus/update',
  async (params: { id: number, name: string, customerBonusId: string, config?: Record<string, any>, value?: number, walletRewards?: BonusWalletReward[], gameRewards?: BonusGameReward[], external?: boolean }, thunkApi) => {
    const { name, customerBonusId, id, config, value, walletRewards, gameRewards, external } = params
    const req = await agent.patch(`${apiUrlV1}/organization/bonus/${id}`, {
      body: JSON.stringify({ name, customerBonusId, config, value, walletRewards, gameRewards, external })
    })
    if (req.ok) {
      thunkApi.dispatch(getBonuses({}));
      thunkApi.dispatch(addNotification({ status: 'success', text: "Successfully saved" }))
    }
    if (!req.ok) {
      const data = await req.json() as { message: string }
      thunkApi.dispatch(addNotification({ status: 'error', text: data.message }))
      throw Error("Bonus with this name already exists");
    }
  }
)

export const deleteV3GlobalBonus = createAsyncThunk(
  `bonus/delete`,
  async (params: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${apiUrlV1}/organization/bonus/${params.id}`)
      if (response.ok) {
        thunksApi.dispatch(addNotification({ status: 'success', text: "Bonus deleted" }))
        thunksApi.dispatch(getBonuses({}));
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)